var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bulk-actions-bar" },
    [
      _c("div", { staticClass: "bulk-actions-container" }, [
        _c("div", { staticClass: "selection-section" }, [
          _c("div", { staticClass: "selection-info" }, [
            _c("div", { staticClass: "selection-badge" }, [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("check_circle"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "count" }, [
                _vm._v(_vm._s(_vm.selectedCount)),
              ]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "selection-text" }, [
              _vm._v(_vm._s(_vm.$t("auto.selected"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "selection-controls" }, [
            _c(
              "button",
              {
                staticClass: "control-btn",
                attrs: { title: _vm.$t("auto.selectAll") },
                on: {
                  click: function ($event) {
                    return _vm.$emit("select-all")
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("select_all"),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("auto.selectAll")))]),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "control-btn",
                attrs: { title: _vm.$t("auto.clearSelection") },
                on: {
                  click: function ($event) {
                    return _vm.$emit("deselect-all")
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("clear")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("auto.clear")))]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actions-container" },
          [
            _c(
              "a-tooltip",
              { attrs: { title: _vm.$t("auto.addTag"), placement: "bottom" } },
              [
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    on: {
                      click: function ($event) {
                        return _vm.onAction("add-tags")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("label"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("auto.tag")))]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-tooltip",
              {
                attrs: {
                  title: _vm.$t("auto.addDepartment"),
                  placement: "bottom",
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    on: {
                      click: function ($event) {
                        return _vm.onAction("add-preferred-department")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("apartment"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("auto.department")))]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-tooltip",
              { attrs: { title: _vm.$t("auto.addUser"), placement: "bottom" } },
              [
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    on: {
                      click: function ($event) {
                        return _vm.onAction("add-preferred-agents")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("person"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("auto.userwith")))]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-tooltip",
              {
                attrs: {
                  title: _vm.$t("auto.giveOwnership"),
                  placement: "bottom",
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    on: {
                      click: function ($event) {
                        return _vm.onAction("set-owner")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("assignment_ind"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("auto.owner")))]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-tooltip",
              { attrs: { title: _vm.$t("auto.addNote"), placement: "bottom" } },
              [
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    on: {
                      click: function ($event) {
                        return _vm.onAction("add-note")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("note_add"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("auto.note")))]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-tooltip",
              {
                attrs: {
                  title: _vm.$t("auto.updateProfileField"),
                  placement: "bottom",
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    on: {
                      click: function ($event) {
                        return _vm.onAction("add-contact-property")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("badge"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("auto.profileField")))]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-tooltip",
              {
                attrs: {
                  title: _vm.$t("auto.markAsAnswered"),
                  placement: "bottom",
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    on: {
                      click: function ($event) {
                        return _vm.onAction("mark-as-answered")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("mark_email_read"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("auto.answered")))]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-tooltip",
              {
                attrs: {
                  title: _vm.$t("auto.markAsRead"),
                  placement: "bottom",
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    on: {
                      click: function ($event) {
                        return _vm.onAction("mark-as-read")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("done_all"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("auto.read")))]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-tooltip",
              {
                attrs: { title: _vm.$t("auto.vipStatus"), placement: "bottom" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    on: {
                      click: function ($event) {
                        return _vm.onAction("set-vip")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("star"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("message.vipBadge")))]),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "close-btn",
            attrs: { title: _vm.$t("auto.close") },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
        ),
      ]),
      _vm._v(" "),
      _c("BulkAddTagsModal", {
        attrs: {
          visible: _vm.bulkModal.visible && _vm.bulkModal.type === "tags",
          "selected-count": _vm.selectedCount,
        },
        on: { confirm: _vm.onBulkModalConfirm, cancel: _vm.onBulkModalCancel },
      }),
      _vm._v(" "),
      _c("BulkAddDepartmentModal", {
        attrs: {
          visible: _vm.bulkModal.visible && _vm.bulkModal.type === "department",
          "selected-count": _vm.selectedCount,
        },
        on: { confirm: _vm.onBulkModalConfirm, cancel: _vm.onBulkModalCancel },
      }),
      _vm._v(" "),
      _c("BulkAssignUserModal", {
        attrs: {
          visible: _vm.bulkModal.visible && _vm.bulkModal.type === "user",
          "selected-count": _vm.selectedCount,
        },
        on: { confirm: _vm.onBulkModalConfirm, cancel: _vm.onBulkModalCancel },
      }),
      _vm._v(" "),
      _c("BulkSetOwnerModal", {
        attrs: {
          visible: _vm.bulkModal.visible && _vm.bulkModal.type === "owner",
          "selected-count": _vm.selectedCount,
          "selected-contacts": _vm.selectedContacts,
        },
        on: { confirm: _vm.onBulkModalConfirm, cancel: _vm.onBulkModalCancel },
      }),
      _vm._v(" "),
      _c("BulkAddNoteModal", {
        attrs: {
          visible: _vm.bulkModal.visible && _vm.bulkModal.type === "note",
          "selected-count": _vm.selectedCount,
        },
        on: { confirm: _vm.onBulkModalConfirm, cancel: _vm.onBulkModalCancel },
      }),
      _vm._v(" "),
      _c("BulkSetPropertyModal", {
        attrs: {
          visible: _vm.bulkModal.visible && _vm.bulkModal.type === "property",
          "selected-count": _vm.selectedCount,
        },
        on: { confirm: _vm.onBulkModalConfirm, cancel: _vm.onBulkModalCancel },
      }),
      _vm._v(" "),
      _c("BulkSetVipModal", {
        attrs: {
          visible: _vm.bulkModal.visible && _vm.bulkModal.type === "vip",
          "selected-count": _vm.selectedCount,
        },
        on: { confirm: _vm.onBulkModalConfirm, cancel: _vm.onBulkModalCancel },
      }),
      _vm._v(" "),
      _c("BulkMarkAsAnsweredModal", {
        attrs: {
          visible: _vm.bulkModal.visible && _vm.bulkModal.type === "answered",
          "selected-count": _vm.selectedCount,
        },
        on: { confirm: _vm.onBulkModalConfirm, cancel: _vm.onBulkModalCancel },
      }),
      _vm._v(" "),
      _c("BulkMarkAsReadModal", {
        attrs: {
          visible: _vm.bulkModal.visible && _vm.bulkModal.type === "read",
          "selected-count": _vm.selectedCount,
        },
        on: { confirm: _vm.onBulkModalConfirm, cancel: _vm.onBulkModalCancel },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }